import React, { useState ,useRef, useEffect} from 'react';
import { Search, FileText, X, ArrowRight, MessageSquare ,List,Plus,FileMinus,Minus,FilePlus,ChevronsRight,Trash2,Zap} from 'react-feather';
import { useStore } from './StoreContext';
import util from '@utils/utils'
import useCreateSearchFast from '../../hooks/useCreateSearchFast';
import { CompareFiles } from './components/CompareFiles';
import { useSearchParams ,useNavigate} from 'react-router-dom';
import {LoadingDiv } from '@components/LoadingDiv';
import { ReactComponent as SparkSvg } from '@images/icons/spark.svg';

export const PolicyCompareSelectPage = () => {
    const [selectedPolicies, setSelectedPolicies] = useState([null, null]);
    const [searchQuery, setSearchQuery] = useState('');
    const [activeTab, setActiveTab] = useState('recommend'); // 'recommend' or 'pool'
    // const [searchResults, setSearchResults] = useState([]);
    const iframeRef = useRef();
    const IFRAME_ID = 'myQAIframeDivV5'
    const [showQa,setShowQa] = useState( true)
    const { state, actions } = useStore();
    const { loading,data,setQuery} 
    = useCreateSearchFast({manual:true});
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const handleSearch = (value) => {
        if(value){
            setQuery({
                search_content:value,
                // search_type:'speed', //ai ,speed
                no_record:true,
                page_size:30
            })
            document.getElementById('my_policy_compare_modal').showModal()
        }
    };

    // 智能推荐搜索
    const handleRecommendSearch = (value) => {
        if(value){
            setQuery({
                search_content:value,
                // search_type:'speed', //ai ,speed
                no_record:true,
                page_size:10
            })
        }
    };

    useEffect(()=>{
        if(searchParams.get('clickFrom')){
            const clickFrom = searchParams.get('clickFrom')
            const policy = state?.find(i=>i.source_id === clickFrom)
            
            if(policy){
                handleSelectPolicy(policy, 0)
                // 自动搜索推荐对比对象，但不填充搜索框
                if(policy.policy_title || policy.policy_name){
                    handleRecommendSearch(policy.policy_title || policy.policy_name);
                }
            }
        }
    },[searchParams, state])

    const handleSelectPolicy = (policy, index) => {
        const newSelectedPolicies = [...selectedPolicies];
        newSelectedPolicies[index] = policy;
        setSelectedPolicies(newSelectedPolicies);
        // setSearchQuery('');
        // setSearchResults([]);
    };

    const handleRemovePolicy = (index) => {
        const newSelectedPolicies = [...selectedPolicies];
        newSelectedPolicies[index] = null;
        setSelectedPolicies(newSelectedPolicies);
    };

    const isSelected = (policy) => {
        return selectedPolicies.some(p => p && p.source_id === policy.source_id);
    };

    // 清除所有待对比文件池
    const handleClearAllPool = () => {
        actions.updateValue([]);
    };

    const canCompare = selectedPolicies[0] && selectedPolicies[1];
    const pageBack = () => {
        const returnUrl = searchParams.get('returnUrl')
        if(returnUrl){
            window.location.href = returnUrl;
        }else{
            window.location.href = `${process.env.REACT_APP_DOMAIN}policy`
        }
    }
    
    return (
        <div className="md:px-18 lg:px-24 2xl:px-32 3xl:px-36 bg-base-200 w-full flex flex-col h-full " >
            <CompareFiles
                searchInput={searchQuery}
                data={data}
                loading={loading}
                selectedPolicies={selectedPolicies}
                handleSelectPolicy={handleSelectPolicy}
            />
            <div className='m-3 px-6 max-w-[2360px] w-full mx-auto'>
                <div className=' flex items-center'>
                    <span className='hover:primary cursor-pointer' onClick={()=>pageBack()}>返回</span>
                    <div className="divider divider-horizontal"></div>
                    <div className='text-3xl font-bold'>
                        政策对比
                    </div>
                    {/* <div  className="badge badge-neutral ml-2">{state?.length}个政策文件</div> */}
                </div>
            </div>

            <div className='max-w-[2360px] w-full mx-auto xl:flex'>
                <div className='py-8 px-20 bg-base-100 m-3 flex flex-col shadow-lg flex-1'>

                    {/* Tab Navigation */}
                    <div role="tablist" className="tabs tabs-lg tabs-bordered mb-6">
                        <a 
                            role="tab"
                            className={`tab ${activeTab === 'recommend' ? 'tab-active' : ''}`}
                            onClick={() => setActiveTab('recommend')}
                        >
                            <SparkSvg className="w-5 h-5 mr-2"/>
                            对比对象推荐
                            {data?.length > 0 && <div className="badge badge-sm badge-neutral ml-2">{data?.length}</div>}
                        </a>
                        <a 
                            role="tab"
                            className={`tab ${activeTab === 'pool' ? 'tab-active' : ''}`}
                            onClick={() => setActiveTab('pool')}
                        >
                            <List size="1.2rem" className="mr-2"/>
                            待对比文件池
                            <div className="badge badge-sm badge-neutral ml-2">{state?.length}</div>
                        </a>
                    </div>

                    {/* 智能推荐对比 Tab */}
                    {activeTab === 'recommend' && (
                        <div className="space-y-2">
                            <div className='max-h-[32vh] overflow-y-auto space-y-2 pr-4 relative'>
                                {loading ? (
                                    <LoadingDiv/>
                                ) : data?.length > 0 ? (
                                    <>
                                    {data.map((policy,index) => (
                                        <div
                                            key={policy.source_id}
                                            className={`flex items-center justify-between py-3 px-6 rounded-lg transition-all duration-200 ${isSelected(policy)
                                                    ? 'bg-[#1ea18b]/5 border border-[#1ea18b]'
                                                    : 'bg-gray-50 hover:bg-gray-100'
                                                }`}
                                        >
                                            <div className='flex-1'>
                                                <div className='text-lg font-bold cursor-pointer hover:text-primary' 
                                                onClick={(e)=>{e.preventDefault();e.stopPropagation();
                                                    window.open(`${process.env.REACT_APP_DOMAIN}policy/file?fileName=${encodeURIComponent(policy?.policy_title || policy?.policy_name)}&fileId=${policy?.source_id}&returnUrl=${encodeURIComponent(window.location.href)}`,'_blank')}}>
                                                    {index+1}. {policy?.policy_title || policy?.policy_name}
                                                </div>
                                                <div className='text-secondary flex gap-2'>
                                                    <span>[{policy.policy_class }]</span>
                                                    <span>政策来源：{policy?.from_organization?.replaceAll(/:/g,"")}</span>
                                                    <span>{util.dateTransformToCN(policy?.policy_time)}</span>
                                                </div>
                                            </div>
                                            {isSelected(policy) ? (
                                                <span className="text-[#1ea18b] text-sm">已选择</span>
                                            ) : (
                                                <div className='flex items-center gap-4'>
                                                    <div className="tooltip" data-tip="添加到文件池">
                                                    <Plus className="w-5 h-5 text-[#1ea18b] cursor-pointer "
                                                        onClick={()=> {
                                                            if(!state?.find(i=>i.source_id === policy?.source_id)){
                                                                actions.updateValue([...state, policy])
                                                            }
                                                        }}
                                                    />
                                                    </div>
                                                    <div className="tooltip" data-tip="添加对比对象">
                                                    <FilePlus className="w-5 h-5 text-[#1ea18b] cursor-pointer " 
                                                    onClick={() => !isSelected(policy) && handleSelectPolicy(policy, selectedPolicies[0] ? 1 : 0)}
                                                    />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                    </>
                                ) : (
                                    <div className="w-full text-center p-8">
                                        <div className="text-gray-500">暂无推荐结果</div>
                                    </div>
                                )}
                                {/* 渐变遮罩 */}
                                {/* <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-base-100 to-transparent"></div> */}

                            </div>
                        </div>
                    )}

                    {/* 待对比文件池 Tab */}
                    {activeTab === 'pool' && (
                        <div className="space-y-2">
                            {/* <div className='flex w-full items-center justify-between mb-4'>
                                <div className='flex items-center gap-2'>
                                    {state?.length > 0 && (
                                        <div className="tooltip" data-tip="清除所有文件">
                                            <button 
                                                className="btn btn-sm btn-ghost text-error hover:bg-error hover:text-white"
                                                onClick={handleClearAllPool}
                                            >
                                                <Trash2 size="1rem"/>
                                                清空
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div> */}
                            <div className='max-h-[32vh] overflow-y-auto space-y-2 pr-4 relative'>
                                {state?.length > 0 ?
                                    <>
                                    {state.map((policy,index) => (
                                        <div
                                            key={policy.source_id}
                                            className={`flex items-center justify-between py-3 px-6 rounded-lg transition-all duration-200 ${isSelected(policy)
                                                    ? 'bg-[#1ea18b]/5 border border-[#1ea18b]'
                                                    : 'bg-gray-50 hover:bg-gray-100'
                                                }`}
                                        >
                                            <div className='flex-1'>
                                                <div className='text-lg font-bold cursor-pointer hover:text-primary' 
                                                onClick={(e)=>{e.preventDefault();e.stopPropagation();
                                                    window.open(`${process.env.REACT_APP_DOMAIN}policy/file?fileName=${encodeURIComponent(policy?.policy_title || policy?.policy_name)}&fileId=${policy?.source_id}&returnUrl=${encodeURIComponent(window.location.href)}`,'_blank')}}>
                                                    {index+1}. {policy?.policy_title || policy?.policy_name}
                                                </div>
                                                <div className='text-secondary flex gap-2'>
                                                    <span>[{policy.policy_class }]</span>
                                                    <span>政策来源：{policy?.from_organization?.replaceAll(/:/g,"")}</span>
                                                    <span>{util.dateTransformToCN(policy?.policy_time)}</span>
                                                </div>
                                            </div>
                                            {isSelected(policy) ? (
                                                <span className="text-[#1ea18b] text-sm">已选择</span>
                                            ) : (
                                                <div className='flex items-center gap-4'>
                                                    <div className="tooltip" data-tip="移出文件池">
                                                    <Minus className="w-5 h-5 text-[#1ea18b] cursor-pointer "
                                                        onClick={()=> actions.updateValue([...state?.filter(i=>i.source_id !== policy?.source_id)])                                                                        }
                                                    />
                                                    </div>
                                                    <div className="tooltip" data-tip="添加对比对象">
                                                    <FilePlus className="w-5 h-5 text-[#1ea18b] cursor-pointer " 
                                                    onClick={() => !isSelected(policy) && handleSelectPolicy(policy, selectedPolicies[0] ? 1 : 0)}
                                                    />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                    </>
                                    :
                                    <div className="w-full text-center p-8">
                                        <div className="text-gray-500">暂无内容</div>
                                        <div className="text-sm text-gray-400 mt-2">可通过推荐结果或在线搜索添加文件</div>
                                    </div>

                                }
                                {/* 渐变遮罩 */}
                                <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-base-100 to-transparent"></div>

                            </div>
                        </div>
                    )}

                    {/* Search Bar for manual search */}
                    <div className="relative my-6 pr-6">
                        <input
                            type="text"
                            placeholder="搜索更多政策文件..."
                            className="w-full pl-4 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1ea18b]"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {handleSearch(e.target.value);}
                            }}

                        />
                        <Search className="absolute right-12 top-3.5 text-gray-400 w-5 h-5" onClick={()=>handleSearch(searchQuery)}/>

                    </div>
                    <div className='flex w-full items-center gap-4 my-6'>
                        <FileText size="1.6rem"/>
                        <div className="card-title">
                        对比对象
                        </div>
                    </div>

                    {/* Policy Selection Area */}
                    <div className="flex gap-4 mb-6">
                            <div key={0} className="flex-1">
                                <div className={`h-[23vh] border-2 ${selectedPolicies[0]
                                        ? 'border-[#1ea18b] bg-[#1ea18b]/5'
                                        : 'border-dashed border-gray-300 hover:border-[#1ea18b] '
                                    } rounded-lg flex items-center justify-center relative transition-all duration-200`}>
                                    {selectedPolicies[0] ? (
                                        <div className="p-8 w-full ">
                                            <button
                                                onClick={() => handleRemovePolicy(0)}
                                                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                                            >
                                                <X className="w-5 h-5" />
                                            </button>
                                                                                    <div className='text-lg font-bold cursor-pointer hover:text-primary z-10 relative' 
                                        onClick={(e)=>{e.preventDefault();e.stopPropagation();
                                            window.open(`${process.env.REACT_APP_DOMAIN}policy/file?fileName=${encodeURIComponent(selectedPolicies[0]?.policy_title || selectedPolicies[0]?.policy_name)}&fileId=${selectedPolicies[0]?.source_id}&returnUrl=${encodeURIComponent(window.location.href)}`,'_blank')}}>
                                            {selectedPolicies[0]?.policy_title || selectedPolicies[0]?.policy_name}
                                            </div>
                                            <div className='text-secondary mt-2 z-10 relative space-y-1'>
                                                <div>[{selectedPolicies[0].policy_class }]</div>
                                                <div>政策来源：{selectedPolicies[0]?.from_organization?.replaceAll(/:/g,"")}</div>
                                                <div>{util.dateTransformToCN(selectedPolicies[0]?.policy_time)}</div>
                                            </div>
                                            <FileText className="absolute bottom-8 right-8 text-gray-300 opacity-50 w-48 h-48 z-0" />
                                        </div>
                                    ) : (
                                        <div className="text-center text-gray-500">
                                            <FilePlus className="w-16 h-16 mx-auto mb-2" />
                                            <p>点击待对比文件或搜索选择政策文件</p>
                                            <p className="text-sm mt-1">(文件一)</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                                {/* VS Divider */}


                            <div className="flex items-center justify-center">
                                <div className="text-2xl rounded-full text-primary flex items-center justify-center font-bold">
                                    VS
                                </div>
                            </div>
                            <div key={1} className="flex-1">
                                <div className={`h-[23vh] border-2 ${selectedPolicies[1]
                                        ? 'border-[#1ea18b] bg-[#1ea18b]/5'
                                        : 'border-dashed border-gray-300 hover:border-[#1ea18b] '
                                    } rounded-lg flex items-center justify-center relative transition-all duration-200`}>
                                    {selectedPolicies[1] ? (
                                        <div className="p-8 w-full ">
                                        <button
                                            onClick={() => handleRemovePolicy(1)}
                                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                                        >
                                            <X className="w-5 h-5" />
                                        </button>
                                        <div className='text-lg font-bold cursor-pointer hover:text-primary z-10 relative' 
                                        onClick={(e)=>{e.preventDefault();e.stopPropagation();
                                            window.open(`${process.env.REACT_APP_DOMAIN}policy/file?fileName=${encodeURIComponent(selectedPolicies[1]?.policy_title || selectedPolicies[1]?.policy_name)}&fileId=${selectedPolicies[1]?.source_id}&returnUrl=${encodeURIComponent(window.location.href)}`,'_blank')}}>
                                            {selectedPolicies[1]?.policy_title || selectedPolicies[1]?.policy_name}
                                        </div>
                                        <div className='text-secondary mt-2 z-10 relative space-y-1'>
                                            <div>[{selectedPolicies[1].policy_class }]</div>
                                            <div>政策来源：{selectedPolicies[1]?.from_organization?.replaceAll(/:/g,"")}</div>
                                            <div>{util.dateTransformToCN(selectedPolicies[1]?.policy_time)}</div>
                                        </div>
                                        <FileText className="absolute bottom-8 right-8 text-gray-300 opacity-50 w-48 h-48 z-0" />
                                    </div>
                                    ) : (
                                            <div className="text-center text-gray-500">
                                                <FilePlus className="w-16 h-16 mx-auto mb-2" />
                                                <p>点击待对比文件或搜索选择政策文件</p>
                                                <p className="text-sm mt-1">(文件二)</p>
                                            </div>
                                        )}
                                    </div>

                            </div>

                    </div>

                    {/* Compare Button */}
                    <button
                        className={`w-1/3 mx-auto mt-6 py-3 rounded-lg font-semibold text-white transition-all duration-200 ${canCompare
                                ? 'bg-[#1ea18b] hover:bg-[#1a8f7c]'
                                : 'bg-gray-300 cursor-not-allowed'
                            }`}
                        disabled={!canCompare}
                        onClick={()=>{
                            const selectedCards = selectedPolicies?.map(i=>{return {policy_id:i?.source_id,policy_title:i.policy_title || i.policy_name,policy_time:i.policy_time,from_organization:i.from_organization}})
                            navigate(`/policy/compare?files=${encodeURIComponent(JSON.stringify(selectedCards))}`)
                    }}
                    >
                        {canCompare ? '开始对比' : '请选择两个政策文件进行对比'}
                    </button>
                </div>

                {process.env.REACT_APP_CLIENT_ID !== 'client-b' && (
                <>
                <div className={`${showQa ? '' : 'hidden'} card bg-base-100 ${process.env.REACT_APP_TYPE === 'grid-build' ? 'h-[91vh]' : 'h-[85vh]'} w-full xl:w-1/3 xl:flex-shrink-0 m-3 shadow-lg sticky top-4`}>
                    <div className='flex justify-between p-3 bg-base-100'>
                        <div className='flex space-x-2'>
                            <div className='card-title px-4 flex gap-4'>
                                <MessageSquare size='1.5rem'/>
                                <span> 对比AI问答</span>
                            </div>
                        </div>
                        <div className='flex'>
                            <div className="divider divider-horizontal mx-1 my-2"></div>
                            <button className={`btn btn-ghost`} onClick={()=>{setShowQa(!showQa)}}>
                                <ChevronsRight size="16"/>
                            </button>
                        </div>
                    </div>
                    <div className="card-body flex flex-col gap-y-4 p-0 ">
                        <div className='flex-1'>
                            <iframe
                                id={IFRAME_ID}
                                ref={iframeRef}
                                allow="clipboard-write; clipboard-read"
                                // src="http://10.10.10.64:3001"
                                // src="http://policyassist.yuyihub.com/llm-qa?version4"
                                src={process.env.REACT_APP_QA_URL}
                                // src={`${process.env.REACT_APP_DOMAIN}qaBuildForGrid/index.html`}
                                width='100%'
                                height='100%'
                            />
                        </div>
                    </div>
                </div>
                <div className={`${showQa ? 'hidden' : ''} fixed bottom-48 right-8`}>
                    <button className="bg-base-100 group btn hover:btn-primary hover:text-white shadow-lg h-4"
                        onClick={()=>{setShowQa(!showQa)}}
                    >
                        <MessageSquare size='1.5rem'/>
                        <span className='group-hover:block hidden'>对比AI问答</span>
                    </button>
                </div>
                </>
                )}
            </div>
        </div>
    )}